

















import Spinner from '@/components/Spinner.vue';
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  components: {
    Spinner
  }
});
